import React from 'react'
import { Box, TextareaAutosize } from '@mui/material'
import { MathjaxPreview } from './MathjaxPreview'

export function Mathjax() {
  const [text, setText] = React.useState('')

  return (
    <>
      <Box>
        <TextareaAutosize
          value={text}
          minRows={15}
          onChange={(e) => setText(decodeURI(e.target.value))}
          style={{ width: '99%' }}
        />
      </Box>
      <Box>
        <MathjaxPreview math={text} />
      </Box>
    </>
  )
}
